import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { ProductVariant } from "../../services/types/productVariant.type";

export const productVariantsApi = createApi({
  reducerPath: "productVariantsApi",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_ADMIN_API_URL, // Например, "https://api.miyukon.store/admin"
    credentials: "include",
  }),
  endpoints: (builder) => ({
    // Получение списка вариантов для товара
    getProductVariants: builder.query<
      ProductVariant[],
      { productUuid: string; includeAll?: boolean }
    >({
      query: ({ productUuid, includeAll }) => {
        let url = `/products/${productUuid}/variants`;
        if (includeAll) url += "?includeAll=true";
        return { url, method: "GET" };
      },
      transformResponse: (response: {
        status: string;
        message: string;
        data: ProductVariant[];
      }) => response.data,
    }),
    // Получение данных по одному варианту
    getProductVariantById: builder.query<
      ProductVariant,
      { productUuid: string; variantUuid: string }
    >({
      query: ({ productUuid, variantUuid }) => ({
        url: `/products/${productUuid}/variants/${variantUuid}`,
        method: "GET",
      }),
      transformResponse: (response: {
        status: string;
        message: string;
        data: ProductVariant;
      }) => response.data,
    }),
    // Создание нового варианта
    createProductVariant: builder.mutation<
      ProductVariant,
      {
        productUuid: string;
        body: { size: string; stock: number; position: number };
      }
    >({
      query: ({ productUuid, body }) => ({
        url: `/products/${productUuid}/variants`,
        method: "POST",
        body,
      }),
      transformResponse: (response: {
        status: string;
        message: string;
        data: ProductVariant;
      }) => response.data,
    }),
    // Обновление существующего варианта (включая поле position)
    updateProductVariant: builder.mutation<
      ProductVariant,
      {
        productUuid: string;
        variantUuid: string;
        body: { size?: string; stock?: number; position?: number };
      }
    >({
      query: ({ productUuid, variantUuid, body }) => ({
        url: `/products/${productUuid}/variants/${variantUuid}`,
        method: "PATCH",
        body,
      }),
      transformResponse: (response: {
        status: string;
        message: string;
        data: ProductVariant;
      }) => response.data,
    }),
    // Удаление (soft-delete) варианта
    deleteProductVariant: builder.mutation<
      { uuid: string },
      { productUuid: string; variantUuid: string }
    >({
      query: ({ productUuid, variantUuid }) => ({
        url: `/products/${productUuid}/variants/${variantUuid}`,
        method: "DELETE",
      }),
      transformResponse: (_: any, __: any, arg) => ({ uuid: arg.variantUuid }),
    }),
  }),
});

export const {
  useGetProductVariantsQuery,
  useGetProductVariantByIdQuery,
  useCreateProductVariantMutation,
  useUpdateProductVariantMutation,
  useDeleteProductVariantMutation,
} = productVariantsApi;
